module.exports = __webpack_public_path__ + "media/4x3/nr-d16edc69.svg";